import React from 'react'
import context from '@/context'
import { AuthProvider } from '@/components/auth/authProvider'
import LanguageSwitch from '@/components/LanguageSwitch'

class SimpleLayout extends React.Component {
  render () {
    const Initializer = context.initializer
    return <div className='anonym-layout' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 20, width: '100%' }}>
      {/* background */}
      <div style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0, background: `url(/bg.jpg)`, backgroundSize: 'cover' }} />
      <AuthProvider>
        <Initializer>
          {this.props.children}
        </Initializer>
      </AuthProvider>
      <div className='language-switch'>
        <LanguageSwitch />
      </div>
    </div>
  }
}

export default SimpleLayout



// WEBPACK FOOTER //
// ./src/layouts/Simple/index.js